<template>
    <div :style="domStyle" v-show="isShow" class="fvMultiTypeCurve">

        <!-- loading  -->
        <Col :style="loadingStyle" span="8" v-show="isloading">
            <Spin fix>
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
        </Col>
        <img :src="shezhiImg" title="添加" v-show="setupTow"  @click="openAddCure" style="position: absolute;
            right: 2%;
            top: 0%;
            width: 1.5%;
            cursor: pointer;
            z-index:900;"
        >
        <img :src="shuaxinImg" title="刷新" v-show="isRenovate"  @click="renovate" style="position: absolute;
            right: 5%;
            top: 0%;
            width: 1.5%;
            cursor: pointer;
            z-index:900;"
        >
        <Modal
            v-model="modalCurve"
            :title= addCurve.title
            :z-index="2000"
            :mask-closable="false"
            draggable >
            <div>
                <Row>
                    <Col span="7">
                        <Table
                            :height="220"
                            size="small"
                            highlight-row ref="currentRowTable"
                            @on-current-change="onCurveList"
                            :columns="curveListTitle"
                            :data="curveListData">
                        </Table>
                        <Button style="width:100%" type="error" @click="DelDataBtn">
                            {{addCurve.del}}
                        </Button>
                    </Col>
                    <Col span="15">
                        <Form :model="formItem" :label-width="80">
                            <FormItem :label="addCurve.curveName">
                                <Input v-model="formItem.curveName" :placeholder="addCurve.name"/>
                                <P style="position: absolute; color: red;">
                                    <Checkbox v-model="formItem.isCurveName" >
                                    </Checkbox>
                                    {{addCurve.isCover}}
                                </P>
                            </FormItem>
                            <FormItem :label="addCurve.curveTag">
                                <Row>
                                    <Col span="16">
                                        <Input v-model="formItem.curveTag" :placeholder="addCurve.tag"/>
                                    </Col>
                                    <Col span="4" offset="1">
                                        <Button @click="openPointList">{{addCurve.getTag}}</Button>
                                    </Col>
                                </Row>
                                <P style="position: absolute; color: red;">
                                    <Checkbox v-model="formItem.isExpand" >
                                    </Checkbox>
                                    {{addCurve.isExpand}}
                                </P>
                            </FormItem>
                            <FormItem :label="addCurve.cordon">
                                <Row>
                                    <Col span="12">
                                        <Row>
                                            <Col span="5">
                                                <Checkbox
                                                    @on-change="checkAllGroupChange"
                                                    v-model="formItem.curveCheckboxUpper"
                                                    :label="addCurve.enable">
                                                </Checkbox>
                                            </Col>
                                            <Col span="16">
                                                <Input
                                                    v-model="upperValue"
                                                    :disabled="isOpenUpper"
                                                    :placeholder="addCurve.upperLimit"/>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span="12">
                                        <Row>
                                            <Col span="5">
                                                <Checkbox
                                                    @on-change="checkAllGroupChange"
                                                    v-model="formItem.curveCheckboxbLower"
                                                    :label="addCurve.enable">
                                                </Checkbox>
                                            </Col>
                                            <Col span="16">
                                                <Input
                                                    v-model="lowerValue"
                                                    :disabled="isOpenLower"
                                                    :placeholder="addCurve.lowerLimit"/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                            </FormItem>
                            <FormItem :label="addCurve.color">
                                <Row>
                                    <Col span="4">
                                        <ColorPicker v-model="formItem.curveColor" recommend  />
                                    </Col>
                                </Row>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancel">{{addCurve.close}}</Button>
                <Button type="primary" size="large" @click="ok">{{addCurve.ok}}</Button>
            </div>
        </Modal>
        <div v-if="isEnable" :style="enableStyle"></div>
        <i-circle :percent="progressNumber" v-show="isProgress" :size="25" :stroke-width="10" style="position: absolute; right: 2%; top: 0%; cursor: pointer; z-index: 2000;">
            <span class="demo-Circle-inner" @click="offLoad">
                <Icon type="ios-close" size="25" style="color:#ff5500"></Icon>
            </span>
        </i-circle>
    </div>
</template>

<style>
/***
    此处Loading的css样式
*/
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
</style>

<script>
import Vue from 'vue';
import { locale, Page } from 'view-design';
import cn from 'view-design/dist/locale/zh-CN';
import en from 'view-design/dist/locale/en-US';
import dragResize from "../../system/dragResize";//页面路径
export default {
    name : "fvMultiTypeCurve",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : 0 + "px",
            top : 0 + "px",
            width : 0 + "px",
            height : 0 + "px"
        }
        //loading样式
        this.loadingStyle = {
            position : "absolute",
            fontSize: "15px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5",
            zIndex:1000
        }
        this.oldTime="";
        //如果不添加点的话，保证程序不崩溃
        if(this.store == null){
            this.store = [];
        }
        this.newStore = this.store.slice();
        this.newStartTime = this.startTime;
        this.newEndTime = this.endTime;
        this.newTimeStep  = this.timeStep;
        this.newCurveType = this.dataType;
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(this.$store.state.system.$.languageName== "ch"){
            locale(cn);
        }else{
            locale(en);
        }
        this.monitorGoTo();
        //0是趋势， 1是原始
        this.hisType = 0;
        if(this.curveType=="5"){
            for (let i = 0; i < this.store.length; i++) {
                const element = this.store[i];
                element.color="";
            }
        }else{
            for (let i = 0; i < this.store.length; i++) {
                const element = this.store[i];
                if(element.color==""){
                    element.color="#333";
                }
            }
        }
    },
    mounted : function(){
        //是否显示悬浮框
        if(this.hasLegend == "yes"){
            this.hasLegend = true;
        }else{
            this.hasLegend = false;
        }
        // this.formatterDigit = 0; //保留几位小数
        // this.Legend = true; //是否选择图例
        // this.setup = true;//是否显示点选择

        this.initOption();    //创建曲线（无数据）
        this.UpDateData();
        this._getPointValue();
        //this.setMultilingual();
        this.addCurvelist = {
            title : "添加曲线",
            del:"删除",
            curveName:"曲线名称",
            isCover:"是否需要用点描述覆盖曲线名",
            curveTag:"曲线点",
            getTag:"获取点",
            cordon:"警戒线",
            enable:"启",
            upperLimit:"上限值",
            lowerLimit:"下限值",
            color:"颜色",
            ok:"确定",
            close:"取消",
            tag:"点",
            name:"名称",
            isExpand:  this.$store.state.system.$.languageName == "ch" ? "是否需要把点列表全部展开" : "Expand list"
        };
        this.isloading = false;
        this.addCurve = JSON.parse(JSON.stringify(this.addCurvelist));
    },
    data : function(){
        return {
            HisData:[],
            defaultNo : 1,
            defaultName : "曲线",
            isProgress : false,
            progressNumber : 0,
            addCurve : {},
            setup : false,//点选择
            setupTow : false,
            //组件名称
            name : "newCommunication",
            shezhiImg:require('../../../assets/添加.png'),
            shuaxinImg:require('../../../assets/刷新.png'),
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在vueCreated(创建完毕，挂载前)函数中初始化
            domStyle : {},
            //loading样式
            loadingStyle:{},
            colorId : 0,
            //开启实自适应
            // ScaleMark:0,
            //曲线历史实时点最大值最小值
            curveMaxNum : 0,
            isNumericalValue : 0,
            curveMiniNum : 0,
            dataAll : [],
            minimumScale:0,
            largestScale:100,
            data : [],
            curve : undefined,
            isDraw : false,
            startTimeOut : false,
            endTimeOut : false,
            isColorArr : [],
            limitInfo:{},
            //警戒线勾选以及值
            upperLimit : "",
            upperShow : 0,
            lowerLimit : "",
            lowerShow : 0,
            //删除点名称
            deleteName : "",
            //弹窗列表form表单
            formItem: {
                curveName:"",
                curveTag:"",
                curveColor:"#19be6b",
                curveCheckboxUpper:false,
                curveCheckboxbLower:false,
                isCurveName:true,
                isExpand:false
            },
            //警戒线上下限起始值勾选input框显示隐藏
            isOpenUpper:true,
            isOpenLower:true,
            //警戒线上线值
            upperValue:"",
            //警戒线下线值
            lowerValue:"",
            //弹窗显示隐藏
            modalCurve: false,
            //曲线列表标题
            curveListTitle: [ {
                        title: '名称',
                        align: 'center',
                        key: 'name'
                    }],
            //曲线列表数据
            curveListData: [],
            //曲线线型
            linetype:"line",
            isloading:false,
            //标记使用点击，还是悬浮
            triggerOn:"mousemove", //mousemove|click ,mousemove
            isRenovate:true, //刷新按钮,
            viewVersion:"10.0.3.3"
        }
    },
     components:{
      dragResize
    },
    methods : {
        offLoad(){
            this.HisData = [];
            this.$Notice.warning({
                title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                desc: false ? '' : this.$store.state.system.$.languageName == "ch" ? "终止继续请求,请求数据未完成,如需完整数据请重新查询数据!" : "Stop to continue the request, the requested data is not completed, if you need complete data, please re-query data"
            });
            this.isProgress = false;
            this.setupTow = this.setup;
        },
        /**
         * 作用：监听页面切换或最小化，曲线重新绘制
         */
        monitorGoTo(){
            document.addEventListener('visibilitychange',() => {
                if(document.hidden == false){
                    this.setupTow = false;
                    if(this.dataType == 0){
                        this.UpDateData();
                    }
                }
            }, false);
        },
        /*
            参数：currentRow ：返回当前点击的数据
            作用：点击曲线列表
        */
        onCurveList(currentRow){
            this.deleteName = currentRow.data;
        },
        /*
            参数：无
            作用：打开点弹窗
        */
        openPointList(){
            if(window.isApp()){
                this.showDataDialog().then(function(req){
                    if(req){
                        this.formItem.curveTag = req.name;
                        if(this.formItem.isCurveName){
                            this.formItem.curveName = req.desc;
                        }
                    }
                }.bind(this));
            }else{
                if(!this.formItem.isExpand){
                    this.$store.state.system.tagsDialog.$.isExpand=false;
                }else{
                    this.$store.state.system.tagsDialog.$.isExpand=true;
                }
                this.showTagSelectDialog().then(function(req){
                    if(req){
                        this.formItem.curveTag = req.name;
                        if(this.formItem.isCurveName){
                            this.formItem.curveName = req.desc;
                        }

                    }
                }.bind(this));
            }


        },
        /*
            参数：无
            作用：切换 警戒线隐藏显示inpu框
        */
        checkAllGroupChange(){
            if(this.formItem.curveCheckboxUpper){
                this.isOpenUpper = false;

            }else{
                this.isOpenUpper = true;
                this.upperValue = "";
            }
            if(this.formItem.curveCheckboxbLower){
                this.isOpenLower = false;

            }else{
                this.isOpenLower = true;
                this.lowerValue = "";
            }
        },

        handleClearCurrentRow () {
            this.$refs.currentRowTable.clearCurrentRow();
        },
        //弹窗确定按钮
        ok () {
            this.spotColorValue = this.formItem.curveColor;
            this.upperLimit = this.upperValue;
            this.upperShow = this.isOpenUpper ? 0 : 1;
            this.lowerLimit = this.lowerValue;
            this.lowerShow = this.isOpenLower ? 0 : 1;

            if(this.formItem.curveTag != "" && this.formItem.curveName != ""){
              //  this.initOption();
                this.AddData(this.formItem.curveTag,this.formItem.curveName);
                // 更新数据
                this.UpDateData();
                this.modalCurve = false;
            }else{
                if(this.formItem.curveTag == ""){
                    alert(this.$store.state.system.$.languageName== "ch" ? "未选择点！":"Unselected point!");
                }else if(this.formItem.curveName == ""){
                    alert(this.$store.state.system.$.languageName== "ch" ? "没有输入点名称！":"No point name was entered");
                }
            }
        },
        //弹窗关闭按钮
        cancel () {
            this.modalCurve = false;
        },
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            if(this.isDraw == false) return;

            var newTime= new Date().getTime();
            var time_sec = parseInt(Math.floor(newTime/1000));
            var dataTime = parseInt(Math.floor(this.tempDataTime/1000));
            if(time_sec>dataTime&&(time_sec-dataTime)%this.timeStep==0&&time_sec!=this.oldTime){
                this.revoeLine();
                this.oldTime=time_sec;
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.setMultilingual();
            if(scaleObj.titleHeight != 0){
                var titleHeight = 0;
            }else{
                var titleHeight = this.y * this.frameScaleY;
            }
            var scaleY = parseFloat(window.innerHeight-30) / parseFloat(this.$store.state.system.$.screenHeight);
            this.domStyle.left = parseInt(((this.x + this.x * this.frameScaleX)* (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt(((this.y +titleHeight)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";

            //loading自适应
            this.loadingStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.loadingStyle.height =  parseInt((this.height-scaleObj.titleHeight) * (scaleY + scaleObj.zoom)) + "px";
            //加上2个边框
            this.chart.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            //this.chart.style.height = parseInt((this.height-scaleObj.titleHeight) * (scaleY + scaleObj.zoom)) + "px";
            this.chart.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom))+ "px";
            this.curve.resize();



        },
        /*
            多语言title
        */
        setMultilingual() {
            var resText = this.fvSystemApi.getResource(this.originalTitleName);
            if(this.option.title.text != resText){
                this.option.title.text = resText ? resText : this.title;
                this.curve.setOption({
                    title : {
                        text : this.option.title.text
                    }
                });;
            }
            for(var k in this.addCurve){
                var name = this.fvSystemApi.getResource(this.addCurvelist[k]);
                this.addCurve[k] = name ? name : this.addCurvelist[k];
            }


            this.curveListTitle[0].title = this.fvSystemApi.getResource(this.curveListTitle[0].title);


        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        //请求实时
        initRealTimeData(){
            //this.data = [];
            var now = new Date();
            this.tempDataTime = now.getTime();
            for(var i = 0; i < this.store.length; i++){
                var arr = new Array();
                //用当前的时间长度除以当前的步长
                for(var j = 0; j < this.timeLengthStep/this.timeStep+1 ; j++){
                    arr.unshift({
                        name: now.AddSecond(-j*this.timeStep).toString(),  //浮窗的时间
                        data_name: this.store[i].name,       //浮窗各项的名字
                        value: [
                            now.AddSecond(-j*this.timeStep),
                            "-"                              //数据的值
                        ]
                    });
                }
                this.data.push(arr);
            }
        },
        //请求实时前请求历史
        initHisTimeData(rebackHisMessage){
            if(rebackHisMessage.varList.length==0){
                return
            }
            if(this.dataType == 1){
                var tmpStart = new Date(this.startTime).getTime();
                var tmpEnd = (new Date(this.endTime).getTime())+(this.timeStep*1000);
                var tmpTime = new Date(this.startTime);
            }else{
                var tStart=new Date().getTime();
                var tmpStart =tStart-(this.timeLengthStep*1000);
                var tmpEnd = tStart;
                var tmpTime = new Date(tmpStart);
            }
            this.data = [];
            this.dataAll = [];
            var range = (tmpEnd - tmpStart)/1000;
            var count = parseInt(range/this.timeStep);
            for(var i = 0; i<this.store.length; i++){
                var arr = new Array();
                var oldNum=0;
                //为了防止添加两条曲线用同样的点， 因为数据库不会注册同样的点，
                for(var k in rebackHisMessage.varList){
                    var varName = rebackHisMessage.varList[k].varName.replace(/\\/g, '.')+ ".PV";
                    if(varName[0].indexOf(".")>-1){
                        varName = varName.substr(1,varName.length-1);
                    }
                    this.store[i].data = this.store[i].data.split("$").join("");
                    //使用添加的曲线去从数据库接口匹配数据
                    if(this.store[i].data == varName){
                        //修改曲线历史如果没有返回某一条数据， 但是图例需要显示， 所以需要重新排序增加一条新
                        if(this.store[i].data != varName){
                            rebackHisMessage.varList.splice(i,0,{
                                varName: "\\"+this.store[i].data.replace(/\./g, '\\'),
                                desc:"因查询数据无数据，为假数据",
                                valueList: []
                            })
                        }
                        for(var j = 0; j< rebackHisMessage.varList[k].valueList.length; j++){
                            if(this.deprecatedTime==1){//过滤无效点如果过滤把无效点的-9999替换成“-”
                                if(rebackHisMessage.varList[k].valueList[j].PV == -9999){
                                    rebackHisMessage.varList[k].valueList[j].PV = "-";
                                }
                            }

                            this.curveMaxNum = Math.max.apply(null,this.dataAll);
                            this.curveMiniNum = Math.min.apply(null,this.dataAll);
                            //获取历史平均值
                            this.dataAll.push(rebackHisMessage.varList[k].valueList[j].PV)
                            this.averagNum = this.average(this.dataAll);
                            arr.push({
                                name: tmpTime.AddSecond(j*this.timeStep).toString(),
                                data_name: this.store[i].name,       //浮窗各项的名字
                                value: [
                                    tmpTime.AddSecond(j*this.timeStep),
                                    rebackHisMessage.varList[k].valueList[j].PV            //数据的值
                                ]
                            });
                        }

                        if(rebackHisMessage.varList[k].valueList.length !=  0 ){
                            this.data.push(arr);
                        }
                    }
                }

            }
            return count;
        },
        //请求历史
         getInitHisTimeData(rebackHisMessage){
             if(this.data.length != 0){
                this.datai = this.data ;
                this.dataIS = true;
             }else{
                 this.dataIS = false;
             }
            if(rebackHisMessage.varList.length==0){
                return
            }
            if(this.dataType == 1){
                var tmpStart = new Date(this.startTime).getTime();
                var tmpEnd = (new Date(this.endTime).getTime())+(this.timeStep*1000);
                var tmpTime = new Date(this.startTime);
            }else{
                var tStart=new Date().getTime();
                var tmpStart =tStart-(this.timeLengthStep*1000);
                var tmpEnd = tStart;
                var tmpTime = new Date(tmpStart);
            }
            this.dataAll = [];
            this.data = [];
            var range = (tmpEnd - tmpStart)/1000;
            var count = parseInt(range/this.timeStep);
            for(var i = 0; i<this.store.length; i++){
                var arr = new Array();
                var oldNum=0;
                //为了防止添加两条曲线用同样的点， 因为数据库不会注册同样的点，
                for(var k in rebackHisMessage.varList){
                    var varName = rebackHisMessage.varList[k].varName.replace(/\\/g, '.')+ ".PV";
                    if(varName[0].indexOf(".")>-1){
                        varName = varName.substr(1,varName.length-1);
                    }
                    this.store[i].data = this.store[i].data.split("$").join("");
                    //使用添加的曲线去从数据库接口匹配数据
                    if(this.store[i].data == varName){
                        //修改曲线历史如果没有返回某一条数据， 但是图例需要显示， 所以需要重新排序增加一条新
                        if(this.store[i].data != varName){
                            rebackHisMessage.varList.splice(i,0,{
                                varName: "\\"+this.store[i].data.replace(/\./g, '\\'),
                                desc:"因查询数据无数据，为假数据",
                                valueList: []
                            })
                        }

                        for(var j = 0; j< rebackHisMessage.varList[k].valueList.length; j++){
                            if(this.deprecatedTime==1){//过滤无效点如果过滤把无效点的-9999替换成“-”
                                if(rebackHisMessage.varList[k].valueList[j].PV == -9999){
                                    rebackHisMessage.varList[k].valueList[j].PV = "-";
                                }
                            }
                            this.curveMaxNum = Math.max.apply(null,this.dataAll);
                            this.curveMiniNum = Math.min.apply(null,this.dataAll);
                            //获取历史平均值
                            this.dataAll.push(rebackHisMessage.varList[k].valueList[j].PV)
                            this.averagNum = this.average(this.dataAll);
                            arr.push({
                                name: this.timestampToTime(rebackHisMessage.varList[k].valueList[j].TIME),
                                data_name: this.store[i].name,       //浮窗各项的名字
                                value: [
                                    this.timestampToTime(rebackHisMessage.varList[k].valueList[j].TIME),
                                    rebackHisMessage.varList[k].valueList[j].PV            //数据的值
                                ]
                            });
                        }
                        if(rebackHisMessage.varList[k].valueList.length !=  0 ){
                            this.data.push(arr);
                        }

                    }
                }
            }
            if(this.dataIS){
                for(var i =0 ;i<this.datai.length;i++){
                    this.data[i] = this.datai[i].concat(this.data[i]);
                }
            }
            return count;
        },
        getTreeData(){
            window.mySocketManager.sendMessage(
                {
                    "head" : "getTags",
                    "message" : {}
                },this.onClicks.bind(this)
            )
        },
        /**
         * 作用：初始化曲线
         */
        initOption(){
            //判断是否是定制y轴区间， 显示刷新按钮
            this.isRenovate = this.ScaleMark==2 ? true:false;
            //定制功能是鼠标悬浮不是点击
            this.triggerOn = this.infoType == 1 || this.infoType == undefined ? "mousemove" : "click";
            this.yAxisShow = this.yAxisShow == undefined?true:this.yAxisShow;
            //初始化曲线图
            if(this.isBar){
                this.linetype = "bar";
            }
            if(this.transparent){
                var backColor = "rgba(128, 128, 128,0)";
            }else{
                var backColor = this.backgroundColor;
            }

            this.originalTitleName = this.title;
            var resText = this.fvSystemApi.getResource(this.originalTitleName);
            this.titleSize = this.titleSize ? this.titleSize :20;
            this.option = {
                backgroundColor: backColor,//设置背景色 curveBackgroundColor
                title: {
                    text: resText ? resText : this.originalTitleName,
                    left: this.titleLocation,
                    textStyle:{
                        fontSize:this.titleSize,
                        color:this.titleColor,//标题颜色
                    },
                    zlevel: 1000
                },
                grid: {},
                legend: {
                    type: 'scroll',
                    show: this.Legend,//是否显示图例
                    data:[],
                    textStyle: {
                        fontSize: 14
                    },
                    // orient:'vertical',
                    width :"100%",
                    right: 0,
                    //left:0,
                    top:25,
                    selected: {}
                },
                tooltip: {//悬的弹窗
                    // show: this.hasLegend,
                    trigger:  'axis',
                    backgroundColor: '#fff',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            label: {
                                show: true,
                                backgroundColor: '#fff',
                                color: '#556677',
                                borderColor: 'rgba(0,0,0,0)',
                                shadowColor: 'rgba(0,0,0,0)',
                                shadowOffsetY: 0
                            },
                        }
                    },
                    confine:true,
                    // triggerOn: this.triggerOn,//mousemove|click
                    // alwaysShowContent:this.isRenovate,//是否始终显示
                    formatter: function (params,ticket) {
                        this.offectiveNum = 2;
                        var str = "";
                        for(var i = 0; i<params.length; i++ ){
                            var date = new Date(params[i].name);
                            if(params[i].value[1]=="-"||params[i].value[1]==undefined){
                                var paramsValue = 0.00;
                            }else{
                                if(params[i].value[1]){
                                    //var paramsValue = params[i].value[1].toFixed(this.offectiveNum);
                                    var paramsValue = Math.floor(params[i].value[1] * Math.pow(10,this.formatterDigit)) / Math.pow(10,this.formatterDigit);
                                }else{
                                    var paramsValue = 0.00
                                }
                            }
                            str += '<span style="display:blcok;color:' + params[i].color  + ';">'
                            +"<b>"+paramsValue  +"</b>"+" "+ params[i].data.data_name + " : "
                            + date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + "<br / >";
                            + '</span>';
                        }
                        // console.log(str)
                        return str;
                    }.bind(this)
                },
                dataZoom: [{//曲线放大缩小
                    type: 'inside',
                }, {
                    show:this.zoomShow,//显隐放大缩小  ZoomShow
                    start: 0,
                    end: 10
                }],
                color:[],
                xAxis: [{
                    type: "time",
                    show: this.yAxisShow,//this.xAxisShow
                    splitLine: {
                        show: true
                    },
                    axisLine: {
                        lineStyle: {
                            color:this.titleColor//设置x轴的颜色
                        }
                    },
                    data:[]
                },],
                yAxis: [{}],//y轴
                series:[],
            };
            //当曲线标题在右侧的时候 将图例的位置进行改变
            if(this.titleLocation == "right"){
                this.option.legend.top = "50px";
            }
            this.chart = document.createElement("div");
            this.chart.style.position = "absolute";
            this.$el.title="";
            this.$el.appendChild(this.chart);
            this.curve = this.$echarts.init(this.chart);
            this.showCurve();

        },
        /**
         * 作用:打开添加点窗口
         */
        openAddCure (){
            this.modalCurve = true;
            this.curveListData = this.store;
            this.isOpenUpper=true;
            this.isOpenLower=true;
            this.upperValue="";
            this.lowerValue="";
            this.formItem.curveName = "";
            this.formItem.curveTag = "";
            this.formItem.curveCheckboxUpper = false;
            this.formItem.curveCheckboxbLower = false;
            this.formItem.curveColor = "#19be6b";
        },
        async showTagSelectDialog(){
            var tagName;
            if(this.store.length>0){
                await this.fvSystemApi.selectTagsShow(this.curveListData[this.curveListData.length-1].data,true,true,true).then(function(name){
                    tagName = name;
                })
            }else{
                await this.fvSystemApi.selectTagsShow("Test.测试1.tag1.PV",true,true,true).then(function(name){
                    tagName = name;
                })
            }

            return tagName;
        },
        async showDataDialog(){
            var tagName;
            await this.fvSystemApi.selectDataShow().then(function(name){
                tagName = name;
            })
            return tagName;
        },
        //设置曲线时间轴长度
        /**
         * 作用：设置曲线时间轴长度
         * 参数：秒
         */
        setRealTimeLength(time){
            this.timeLengthStep=time;
            //this.UpDateData();
        },
        /**
         * 作用：设置曲线的数值轴区间
         * 参数ScaleMark:是否启用，0:不启用;1:启用
         * 参数max:最大值
         * 参数min:最小值
         */
        setScaleMark(ScaleMark,max,min){
            this.ScaleMark=ScaleMark;
            if(this.ScaleMark==1){
                this.minimumScale=min;
                this.largestScale=max;
                this.option.yAxis.min=this.minimumScale;
                this.option.yAxis.max=this.largestScale;
            }else{
                delete this.option.yAxis.min;
                delete this.option.yAxis.max;
            }
            this.curve.clear();
            this.curve.setOption(this.option,true);
        },
        //自动设置区间值 最大值
        autoSetMarkMax(i){
            var max =this.getMax(this.data[i]);
            var min = this.getMin(this.data[i]);
            var maxPlusN = parseFloat(this.customYHeight) ? parseFloat(this.customYHeight):1;
            this.largestScale=parseInt(max);
            if(!this.largestScale) {
                this.largestScale = 0;
            }
            if(this.isNumericalValue){
                var num = (max-min)*(maxPlusN/100);
                if(num<1){ num = 1; }
                this.option.yAxis[i].max = Math.ceil(max+num);
            }else{
                this.option.yAxis[i].max=this.largestScale+maxPlusN;
            }
            this.curve.clear();
            this.curve.setOption(this.option,true);
        },
        //自动设置区间值 最小值
        autoSetMarkMin(i){
            var max =this.getMax(this.data[i]);
            var min = this.getMin(this.data[i]);

            var minPlusN = parseFloat(this.customYHeight) ? parseFloat(this.customYHeight):1;
            this.minimumScale=parseInt(min);
            if(!this.minimumScale) {
                this.minimumScale = 0;
            }
            if(this.isNumericalValue){
                var num = (max-min)*(minPlusN/100);
                if(num<1){ num = 1; }
                this.option.yAxis[i].min = Math.floor(min-num);
            }else{
                this.option.yAxis[i].min=this.minimumScale-minPlusN;
            }
            this.curve.clear();
            this.curve.setOption(this.option,true);
        },
        //使用百分比设置量程 /** 待完成，需求有变动()
        /*
        用通过百分比来控制量程，比如现在最大最小值分别为100和0，填写20，量程最大=100+（100-0）*20%=120，最小=0-（100-0）*20%=-20，曲线Y轴就从-20开始到120结束。如果浮动值计算结果小于1，比如最大最小为3和1，（3-1）*20%=0.4就按1算，量程就是0-4。
        */
        autoSetRange(i){
            var max =this.getMax(this.data[i]);
            var min = this.getMin(this.data[i]);
            var num = (max-min)*(this.customYHeight/100);

            if(num<1){ num = 1; }
            this.option.yAxis[i].max = Math.ceil(max+num);
            this.option.yAxis[i].min = Math.floor(min-num);

            this.curve.clear();
            this.curve.setOption(this.option,true);

        },
        /*
        *刷新曲线
        */
        renovate(){
            this.ScaleMark = 2;
            this.curve.clear();
            this.curve.setOption(this.option,true);
        },
        /**
         * 作用：显示曲线
         */
        showCurve(){
            //自适应历史和实时
            this.curve.setOption(this.option,true);
            this.curve.cycle = 0;
            this.curve.resize();
            //关闭加载中
            this.$Spin.hide();
        },
        registerTag(rebackMessage,dataDesc){
            if(rebackMessage){
                this.addTagData(rebackMessage,dataDesc);
            }else{
                console.log("数据库中没有该数据点");
            }
        },

        addTagData(dataName,dataDesc){
            this.revoeLineOpen = true;
            for(var i = 0;i<this.isColorArr.length;i++){
                if(dataName+'.PV' == this.isColorArr[i].name){
                    this.spotColorValue = this.isColorArr[i].color;
                }else{
                    this.spotColorValue = "rgb(0,0,0)";
                }
            }
            //上限值 this.store[i].upperLimit  数值
            //上限警戒线是否显示 this.store[i].upperShow  0/1

            //下限值 this.store[i].lowerLimit  数值
            //下限警戒线是否显示this.store[i].lowerShow  0/1
            //判断如果从组态第一次加载没有颜色，给他赋值初始颜色
            this.spotColorValue = this.spotColorValue ? this.spotColorValue : "#000";
            this.newStore.push({
                "data":dataName + ".PV",
                "name": dataDesc,
                "upperLimit":this.upperLimit,
                "upperShow":this.upperShow,
                "lowerLimit":this.lowerLimit,
                "lowerShow":this.lowerShow,

                "color":this.spotColorValue // this.colorList[this.colorId]
            });
            this.colorId++;
            this.colorId = this.colorId%6;
        },

        delFormDbVar(name){
            if(this.isColorArr.length!=0){
                for(var k =0; k<this.isColorArr.length; k++){
                    if(name==this.isColorArr[k].name){
                        this.isColorArr.splice(k,1);
                    }
                }
            }
            for(var i = 0; i < this.dbVar.length;i++){
                var dbv = this.dbVar[i]+'.PV'
                if(name == dbv){
                    this.dbVar.splice(i,1);
                }
            }
        },

        makeTestMessage(){
            var tmpStart = new Date(this.startTime).getTime();
            var tmpEnd = (new Date(this.endTime).getTime())+this.timeStep;
            var range = (tmpEnd - tmpStart)/1000;
            var count = range/this.timeStep;

            var testMessage = {
                "head": "dataLayer",
                "message" :{
                    "head":"getHisData",
                    "hisType":this.hisType,
                    "varList":[]
                }
            };
            for(var i = 0; i < this.store.length; i++){
                var tmpArr = [];
                for(var j = 0; j < count; j++){
                    tmpArr.push(Math.random()*100);
                }
                testMessage.varList.push({
                    "varName": this.store[i].data,
                    "valueList": tmpArr
                })
            }
            return testMessage;
        },
        //请求实时调用
        updateRealTimeCurve(){
            this.initRealTimeData();
            if(this.store.length>0){
                this.upDateOption();
            }
            this.showCurve();
            this.isloading = false;
        },
        //回调警戒线监听
        onSetLimit(name,isUpOrLo,value,isShow){
            if(this.limitInfo[name]){
                if(isUpOrLo){
                    this.limitInfo[name].upperLimit = value;
                    this.limitInfo[name].upperIsShow = isShow;
                }else{
                    this.limitInfo[name].lowerLimit = value;
                    this.limitInfo[name].lowerIsShow = isShow;
                }
            }else{
                if(isUpOrLo){
                    this.limitInfo[name] = {
                        upperLimit : value,
                        upperIsShow : isShow
                    }
                }else{
                    this.limitInfo[name] = {
                        lowerLimit : value,
                        lowerIsShow : isShow
                    }
                }
            }
            privateSignal.once(name,function(){ //监听返回   方法在workbench.js  第84行
                for(var i = 0; i<this.store.length; i++){
                    if(this.store[i].name == name){
                        this.store[i].upperLimit = this.limitInfo[name].upperLimit ? this.limitInfo[name].upperLimit : '';
                        this.store[i].upperShow = this.limitInfo[name].upperIsShow ? this.limitInfo[name].upperIsShow : 0;
                        this.store[i].lowerLimit = this.limitInfo[name].lowerLimit ? this.limitInfo[name].lowerLimit : '';
                        this.store[i].lowerShow = this.limitInfo[name].lowerIsShow ? this.limitInfo[name].lowerIsShow : 0;

                    }
                }
                this.upDateOption();
            }.bind(this));
        },
        getMax(data){
            var arr = [];
            if(!data) return Math.max.apply(null,arr);
            for(var i=0;i<data.length;i++){
                if(data[i].value[1] != "-"){
                    arr.push(data[i].value[1]);
                }
            }
            return Math.max.apply(null,arr);
        },
        getMin(data){
            var arr = [];
            if(!data) return Math.min.apply(null,arr);
            for(var i=0;i<data.length;i++){
                if(data[i].value[1] != "-"){
                    arr.push(data[i].value[1]);
                }
            }
            return Math.min.apply(null,arr);
        },
        //实例化样式  以及修改曲线颜色
        upDateOption(){
            //添加曲线后再次开启一次 上下+5 的y轴
            this.ScaleMark = this.isRenovate ? 2:this.ScaleMark;
            //上限值 this.store[i].upperLimit  数值/""
            //上限警戒线是否显示 this.store[i].upperShow  0/1
            //下限值 this.store[i].lowerLimit  数值/""
            //下限警戒线是否显示this.store[i].lowerShow  0/1
            //是否显示  this.store[i].IsOpenOpacity
            this.option.color = [];
            this.option.legend.data = [];
            this.option.series = [];
            this.option.yAxis = [];
            if(this.curveType=="3"){
                this.option.grid=[];
                this.option.xAxis = [];
                this.option.dataZoom[1]["xAxisIndex"]=[];
                this.option.dataZoom[0]["xAxisIndex"]=[];
                for (let index = 0; index < this.store.length; index++) {
                    this.option.dataZoom[0].xAxisIndex.push(parseFloat(index));
                    this.option.dataZoom[1].xAxisIndex.push(parseFloat(index));
                }
                
            }else if(this.curveType=="0"){
                this.option.xAxis = [];
                this.option.dataZoom[1]["xAxisIndex"]=[];
                this.option.dataZoom[0]["xAxisIndex"]=[];
                for (let index = 0; index < this.store.length; index++) {
                    this.option.dataZoom[0].xAxisIndex.push(parseFloat(index));
                    this.option.dataZoom[1].xAxisIndex.push(parseFloat(index));
                }
            }else if(this.curveType=="5"){
                this.option["visualMap"]={
                    show:this.Legend,
                    pieces:[],
                    top:this.option.legend.top,
                    right:this.option.legend.right,
                    outOfRange: {
                        color: this.titleColor
                    }
                }
            }
           // this.curve = this.$echarts.init(this.chart);
           //没有曲线 多y轴必须存有一个y轴对象
            if( this.store.length == 0 ){
                this.option.yAxis = [{}];
            }
            for(var i = 0;i < this.store.length; i++){
                this.store[i].name.length
                var nameLen = this.store[i].name.length;
                if(nameLen< this.store[i].name.length){
                    var nameLen = this.store[i].name.length;
                }
                //设置图例的文本颜色与图例颜色一致
                this.option.legend.data.push(
                    {
                        name:this.store[i].name,
                        textStyle:{color:this.store[i].color}
                    }
                );
                this.option.series.push({
                    name: this.store[i].name,
                    type: this.linetype,
                    dbvar: this.store[i].data,
                    showSymbol: false,
                    yAxisIndex: [i],//多y轴需要id
                    xAxisIndex: [i],//多x轴需要id
                    hoverAnimation: false,
                    data: this.data[i],
                    markLine: {
                        silent: true,
                        lineStyle:{
                            opacity:1
                        },
                        data: [{
                            yAxis: this.store[i].upperLimit,
                            lineStyle:{
                                opacity:this.store[i].upperShow
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'end',
                                    textStyle: {
                                        fontSize: 14
                                    },
                                    //formatter: '{c}'
                                    formatter: ''
                                }
                            }
                        }, {
                            yAxis: this.store[i].lowerLimit,
                            lineStyle:{
                                opacity:this.store[i].lowerShow
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'end',
                                    textStyle: {
                                        fontSize: 14
                                    },
                                    //formatter: '目标:{c}%'
                                    formatter: ''
                                }
                            }
                        }]
                    }
                });
                //启用duoY轴   再web端曲线中有此功能
                if(this.curveType=="1"){
                    for(var a = 0 ; a<this.option.series.length;a++){
                       delete this.option.series[a].xAxisIndex;
                    }
                    this.option.yAxis.push({
                        type: 'value',
                        // name: this.store[i].name,
                        //等待动态值this.store[i].min
                        // scale: true,
                        boundaryGap: ['0%', '100%'],
                        axisLabel: {
                            formatter: '{value} '
                        },
                        position: 'left',
                        //offset: 20,
                        axisTick: { lineStyle: { color: this.store[i].color }, inside: true },
                        nameTextStyle: { color: this.store[i].color },
                        axisLabel: { color: this.store[i].color },
                        axisLine: {
                            lineStyle: {
                                color:this.store[i].color//设置x轴的颜色
                            }
                        },
                        splitLine: { show: true }
                    })
                    this.option.yAxis[i].name=this.store[i].name;
                    if(this.ScaleMark==1){
                        this.option.yAxis[i].min=this.minimumScale;
                        this.option.yAxis[i].max=this.largestScale;
                    }
                    if(this.option.yAxis[i].max != undefined){
                        if(i == 0){
                            this.option.yAxis[i].offset = 0;
                            if(this.option.yAxis[i].max.toString().length == 2){
                                this.option.yAxis[i].width = this.option.yAxis[i].max.toString().length*15;
                            }else if(this.option.yAxis[i].max.toString().length == 3){
                                this.option.yAxis[i].width = this.option.yAxis[i].max.toString().length*10;
                            }else{
                                this.option.yAxis[i].width = this.option.yAxis[i].max.toString().length*10;
                            }
                        }else{
                            if(this.option.yAxis[i].max.toString().length == 2){
                                var a = this.option.yAxis[i-1].width;
                                this.option.yAxis[i].offset = a + this.option.yAxis[i].max.toString().length*15;
                                this.option.yAxis[i].width =a + this.option.yAxis[i].max.toString().length*15*2;
                            }else if(this.option.yAxis[i].max.toString().length == 3){
                                var a = this.option.yAxis[i-1].width;
                                this.option.yAxis[i].offset = a + this.option.yAxis[i].max.toString().length*15;
                                this.option.yAxis[i].width =a + this.option.yAxis[i].max.toString().length*15*2;
                            }else{
                                var a = this.option.yAxis[i-1].width;
                                this.option.yAxis[i].offset = a + this.option.yAxis[i].max.toString().length*15;
                                this.option.yAxis[i].width =a + this.option.yAxis[i].max.toString().length*15*2;
                            }
                        }
                    }else{
                        if(i == 0){
                            this.option.yAxis[i].offset = 0;
                            this.option.yAxis[i].width = 3*15;
                        }else{
                            var a = this.option.yAxis[i-1].width;
                            this.option.yAxis[i].offset = a ;
                            this.option.yAxis[i].width =a + 3*15;
                        }
                    }
                    if(this.store.length !=1){
                        //设置曲线边距
                        this.option.grid.left = this.option.yAxis[this.option.yAxis.length-1].width;
                        this.option.grid.right = 20;

                    }
                }else if(this.curveType=="0"){
                    for(var a = 0 ; a<this.option.series.length;a++){
                       delete this.option.series[a].yAxisIndex;
                    }
                     this.option.xAxis.push({
                        type: 'time',
                        boundaryGap: ['100%', '0%'],
                        //  axisLabel: {
                        //     formatter: '{value} '
                        // },
                        position: 'bottom',
                        // offset: -30*(i+1),
                        axisTick: { lineStyle: { color: this.store[i].color }, inside: true },
                        nameTextStyle: { color: this.store[i].color },
                        axisLabel: { color: this.store[i].color },
                        axisLine: {
                            lineStyle: {
                                color:this.store[i].color//设置x轴的颜色
                            }
                        }
                     })
                     this.option.xAxis[i].name=this.store[i].name;
                     this.option.yAxis= [{
                        show: this.yAxisShow,//this.yAxisShow
                        // boundaryGap: [0, '100%'],
                        axisLine: {
                            lineStyle: {
                                color:this.titleColor//设置x轴的颜色
                            }
                        },
                        splitLine: {
                            show: true
                        }
                    }]
                    if(this.ScaleMark==1){
                        this.option.yAxis[0].min=this.minimumScale;
                        this.option.yAxis[0].max=this.largestScale;
                    }
                     if(i == 0){
                            this.option.xAxis[i].offset = 0;
                            this.option.xAxis[i].height = 3*15;
                        }else{
                            var a = this.option.xAxis[i-1].height;
                            this.option.xAxis[i].offset = a ;
                            this.option.xAxis[i].height =a + 3*15;
                        }
                     if(this.store.length !=1){
                        //设置曲线边距
                        this.option.grid.bottom = this.option.xAxis[this.option.xAxis.length-1].height;
                        this.option.grid.top = 45;

                    }
                }else if(this.curveType=="3"){
                     this.option.grid.push({
                        left: 50,
                        right: 50,
                        height: 100/this.store.length-15+'%',
                        top:100/this.store.length*i+10+'%',
                    })
                    this.option.xAxis.push({
                        type: 'time',
                        nameTextStyle: { color: this.store[i].color },
                        axisLabel: { color: this.store[i].color },
                        gridIndex: i,
                        axisLine: {
                            lineStyle: {
                                color:this.store[i].color//设置x轴的颜色
                            }
                        }
                     })
                    this.option.yAxis.push({
                        show: this.yAxisShow,//this.yAxisShow
                        boundaryGap: [0, '100%'],
                        axisLine: {
                            lineStyle: {
                                color:this.store[i].color//设置x轴的颜色
                            }
                        },
                        gridIndex: i,
                        splitLine: {
                            show: true
                        }
                    })
                   
                    if(this.ScaleMark==1){
                        this.option.yAxis[0].min=this.minimumScale;
                        this.option.yAxis[0].max=this.largestScale;
                    }
                    if(this.titleLocation == "right"){
                       this.option.grid[0].top=this.titleSize+50;
                    }else{
                        this.option.grid[0].top=this.titleSize+25;
                    }
                    // this.this.option.dataZoom[0]["xAxisIndex"]=[];
                    // for (let b = 0; b < this.store.length; b++) {
                    //   this.this.option.dataZoom[0]["xAxisIndex"].push([b]);
                    //   this.this.option.dataZoom[1]["xAxisIndex"].push([b]);
                    // }
                }else if(this.curveType=="5"){
                    for(var a = 0 ; a<this.option.series.length;a++){
                       delete this.option.series[a].yAxisIndex;
                       delete this.option.series[a].xAxisIndex;
                    }
                    this.option.legend.show=false;
                    this.option.visualMap.pieces=[{
                        lt: 0,
                        color: '#AC3B2A'
                    },{
                        gt:0,
                        lte:parseFloat(this.signValue[0]),
                        color:this.signColor[0]
                    },{
                        gt:parseFloat(this.signValue[0]),
                        lte:parseFloat(this.signValue[1]),
                        color:this.signColor[1]
                    },{
                        gt:parseFloat(this.signValue[1]),
                        lte:parseFloat(this.signValue[2]),
                        color:this.signColor[2]
                    }, {
                        gt: parseFloat(this.signValue[2]),
                        color: this.titleColor
                    }]
                    this.option.yAxis= [{
                        show: this.yAxisShow,//this.yAxisShow
                        // boundaryGap: [0, '100%'],
                        axisLine: {
                            lineStyle: {
                                color:this.titleColor//设置x轴的颜色
                            }
                        },
                        splitLine: {
                            show: true
                        }
                    }]
                    if(this.ScaleMark==1){
                        this.option.yAxis[0].min=this.minimumScale;
                        this.option.yAxis[0].max=this.largestScale;
                    }
                }else{
                   for(var a = 0 ; a<this.option.series.length;a++){
                       delete this.option.series[a].yAxisIndex;
                       delete this.option.series[a].xAxisIndex;
                       this.$set(this.option.series[a], 'areaStyle', {});
                    }
                    this.option.yAxis= [{
                        show: this.yAxisShow,//this.yAxisShow
                        // boundaryGap: [0, '100%'],
                        axisLine: {
                            lineStyle: {
                                color:this.titleColor//设置x轴的颜色
                            }
                        },
                        splitLine: {
                            show: true
                        }
                    }]
                    if(this.ScaleMark==1){
                        this.option.yAxis[0].min=this.minimumScale;
                        this.option.yAxis[0].max=this.largestScale;
                    }
                }
                this.option.color.push(this.store[i].color);
            }
            this.revoeLineOpen = false;
            // document.write(JSON.stringify(this.option))
            this.curve.setOption(this.option,true);
            this.showCurve();
        },
        makeMessag(){
            if(this.store.length <= 0){
                return null;
            }
            var varList = [];
            for(var i = 0; i < this.dbVar.length; i++){
                varList.push(this.dbVar[i]);
            }
            if(this.applicationHistory==1&&this.dataType == 0){
                var tStart=new Date().getTime();
                var startTime =tStart-(this.timeLengthStep*1000);
                var endTime = tStart + this.timeStep;
            }else{
                var startTime = new Date(this.startTime).getTime();
                var endTime = (new Date(this.endTime).getTime())+(this.timeStep*1000);
            }
            this.testingStep(this.timeStep);
            var hisStep = this.timeStep;
            //设置为0，是趋势历史，没有原始历史接口所以写为固定值
            var hisType = this.hisType;
            var hisMessage = window.MakeGetHisDataMessage(varList, startTime, endTime, hisType, hisStep);
            return hisMessage;
        },
        //拼接数组
        getCurveMaxName(name){
            var all = [];
            for(var k in this.option.series){
                if(this.option.series[k]){
                    if(this.option.series[k].name == name){
                        for(var i in this.option.series[k].data){
                            if(typeof(this.option.series[k].data[i].value[1])=='number'){
                                all.push(this.option.series[k].data[i].value[1]);
                            }
                        }
                    }
                }
            }
            return all;
        },
        //拼接数组
        getCurveMaxIndex(index){
            var all = [];
            if(this.option.series.length != 0){
                if(this.option.series[index]){
                    for(var i in this.option.series[index].data){
                        if(typeof(this.option.series[index].data[i].value[1])=='number'){
                            all.push(this.option.series[index].data[i].value[1]);
                        }
                    }
                }
            }
            return all;
        },
        /**
        *作用：根据下标获取统计值
        *参数：
        *index 下标
        *value 0最大值 1最小值 2平均值
        */
        GetStatisticsByIndex(index,value){
            var data = this.getCurveMaxIndex(index);
            if(data.length == 0){
                return -9999;
            }
            if(value == 0){
                return Math.max.apply(null,data);//最大值
            }else if(value == 1){
                return Math.min.apply(null,data);//最小值
            }else if(value == 2){//平均值
                var total = eval(data.join("+"));
                return total/data.length;
            }
        },
        /**
        *作用：根据下标获取统计值
        *参数 ：
        *name 名称
        *value 0最大值 1最小值 2平均值
        */
        GetStatisticsByName(name,value){
            var data = this.getCurveMaxName(name)
            if(data.length == 0){
                return -9999;
            }
            if(value == 0){
                return Math.max.apply(null,data);//最大值
            }else if(value == 1){
                return Math.min.apply(null,data);//最小值
            }else if(value == 2){//平均值
                var total = eval(data.join("+"));
                return total/data.length;
            }
        },
        /*
        * 获取当前曲线的 点名称
        * 参数：曲线名称
        */
        GetVarByName(name){
           for(var k in this.store){
                if(this.store[k].name == name){
                   var dbName = this.store[k].data.replace(".PV","");
                    return dbName.replace(/\./g, '\\')+".PV";
                }
            }
        },
        /*
        * 获取当前曲线的 点名称
        * 参数：下标
        */
        GetVarByIndex(index){
            if(index <0) return;
            var dbName = this.store[index].data.replace(".PV","");
            return dbName.replace(/\./g, '\\')+".PV";
        },
        //获取点的做大只和最小是监听
        _getPointValue(){
            //最大值
            Object.defineProperty(this,'maxiNum', {
                get: function() {
                    if(this.curveMaxNum){
                        return this.curveMaxNum;
                    }else{
                        return undefined;
                    }
                },
                set: function(value) {
                    console.error("不可设置最大值");
                }
            });
            //最小值
            Object.defineProperty(this,'miniNum', {
                get: function() {
                    if(this.curveMiniNum){
                        return this.curveMiniNum;
                    }else{
                        return undefined;
                    }
                },
                set: function(value) {
                    console.error("不可设置最小值");
                }
            });
            //平均值
            Object.defineProperty(this,'averageValue', {
                get: function() {
                    if(this.averagNum){
                        return this.averagNum;
                    }else{
                        return undefined;
                    }
                },
                set: function(value) {
                    console.error("不可设置最小值");
                }
            });
        },

        revoeLine(){
            if(this.revoeLineOpen == true) return;
            if(this.dataType == 0){
                var tem = new Array();
                for(var i = 0; i<this.store.length; i++){
                    if(this.store[i].data == "") {
                        var listNumb = undefined;
                    }else{
                        var listNumb = this.fvSystemApi.getReal(this.store[i].data.split("$").join(""));
                    }
                    if(listNumb){
                        listNumb = listNumb.PV
                        var isScaleMark = true;//判断第一次如果是 undefined等有值再去关闭区间y轴
                    }
                    if(this.curveMaxNum == "-"){
                        this.curveMaxNum = 0;
                    }
                    if(this.curveMiniNum == "-"){
                        this.curveMiniNum = 0;
                    }
                    if(listNumb == undefined){
                        var value = this.data[i][this.data[i].length-1];
                        listNumb = value.value[1] ;
                        var isScaleMark = false;
                        // listNumb = "-";
                    }
                    //判断实时大小值
                    if(this.curveMaxNum == 0){
                        this.curveMaxNum = listNumb;
                    }else{
                        if(listNumb > this.curveMaxNum){
                            this.curveMaxNum = listNumb;
                        }
                    }
                    //判断实时大小值
                    if(this.curveMiniNum == 0){
                        this.curveMiniNum = listNumb;
                    }else{
                        if(listNumb < this.curveMiniNum){
                            this.curveMiniNum = listNumb;
                        }
                    }
                    if(this.deprecatedTime==1){
                        if(listNumb==-9999){
                            listNumb ="-";
                        }
                    }
                    this.dataAll.shift();
                    this.dataAll.push(listNumb)
                    if(this.data.length > 0){
                        this.data[i].shift();
                        this.data[i].push({
                            name: new Date().toString(),
                            data_name: this.store[i].name,
                            value: [
                                new Date().setMilliseconds(0),
                                listNumb
                            ]
                        });
                        tem.push({
                            type: this.linetype,
                            data: this.data[i]
                        });
                    }
                    if(this.curveType=="1"){ //是否启用Y轴
                        if(false){
                            this.autoSetRange(i)
                        }else{
                            //判断是否使用个最大值最小值来设置y轴区间
                            this.autoSetMarkMax(i);
                            this.autoSetMarkMin(i);
                        }

                        // this.curve.clear();
                        // this.curve.setOption(this.option,true);
                    }else{
                        if(this.isNumericalValue){
                            var num = (this.curveMaxNum-this.curveMiniNum)*(this.customYHeight/100);
                            if(num<1){ num = 1; }
                            this.option.yAxis[0].max = Math.ceil(this.curveMaxNum+num);
                            this.option.yAxis[0].min = Math.floor(this.curveMiniNum-num);
                            this.curve.clear();
                            this.curve.setOption(this.option,true);
                        }else{
                            ////判断是否使用个最大值最小值来设置y轴区间
                            var maxPlusN = parseFloat(this.customYHeight) ? parseFloat(this.customYHeight):0;
                            this.largestScale=parseInt(this.curveMaxNum);
                            this.option.yAxis[0].max=this.largestScale+maxPlusN;
                            var minPlusN = parseFloat(this.customYHeight) ? parseFloat(this.customYHeight):0;
                            this.minimumScale=parseInt(this.curveMiniNum);
                            this.option.yAxis[0].min=this.minimumScale-minPlusN;
                            this.curve.clear();
                            this.curve.setOption(this.option,true);
                        }
                    }
                }
                //获取实时平均值
                this.averagNum = this.average(this.dataAll);
                this.curve.setOption({
                    series: tem,
                    title: {
                    }
                });
            }
        },
        /**
         * 作用:计算平均值
         * 参数：数组
         */
        average(arr){
            var sum=0;
            for (var i = 0; i < arr.length; i++) {
                sum += parseInt(arr[i]);
            };
            var avg = Math.ceil(sum/arr.length);
            return avg;
        },
        /**
         * 作用  请求数据 接口
         */
        UpDateData: function(name){
            //添加曲线后再次开启一次 上下+5 的y轴
            this.ScaleMark = this.isRenovate ? 2:this.ScaleMark;
            //如果请求历史数据还没请求结束不再更新数据
            if(this.isProgress == true) return;
            if(this.startTimeOut || this.endTimeOut){
                return;
            }
            // if(this.newCurveType == 0){
            //     //判断如果时间间隔数据大于3600 个点 重新计算时间间隔请求数据
            //     var step = ((new Date(this.newEndTime)).getTime()/1000-(new Date(this.newStartTime)).getTime()/1000)/this.newTimeStep;
            //     if(step>3600){
            //         this.newTimeStep = parseInt(((new Date(this.newEndTime)).getTime()/1000-(new Date(this.newStartTime)).getTime()/1000)/3600);
            //     }
            // }
            //开启加载中
            this.$Spin.show();
            this.store = this.newStore.slice();
            this.startTime = this.newStartTime;
            this.endTime = this.newEndTime;
            //判断结束时间不能小于结束时间
            this.timeStep = this.newTimeStep;
            this.testingStep(this.timeStep);
            this.dataType = this.newCurveType;
            if(this.dataType == 0){
                this.setupTow = this.setup;
                if(this.applicationHistory==1){
                    var data = this.makeMessage();
                    if(data){
                        this.fvSystemApi.getHistory(data).then((result) =>{
                            this.ShowDataOnCurve(result);
                            this.updateRealTimeCurve();
                            this.isDraw = true;
                        }).catch((reason) =>{
                            if(reason.error == "获取历史请求较多，请等待"){
                                setTimeout(()=>{
                                    this.getHistorydatas(reason,i);
                                },1000)
                            }else{
                                console.log('失败：' + reason);
                            }
                        });
                    }
                }else{
                    this.data = [];
                    this.updateRealTimeCurve();
                    this.isDraw = true;
                }
            }else {
                this.data = [];
                this.isloading = true;
                this.setupTow = false;
                Promise.all([
                    this.makeMessageHis(),
                ]).then(async () => {
                    var percentage = 100/this.HisData.length;
                    this.isProgress = true;
                    for(var i=0;i<this.HisData.length;i++){
                        await this.fvSystemApi.getHistory(this.HisData[i]).then( (response) => {
                            //请求回来更新进度环百分比
                            this.progressNumber = percentage*(i+1);
                            for(var k in response.varList){
                                ///用于判断是否是最后一个元素时间超出时间范围 超出删除最后一个元素
                               var endListTime = new Date(response.varList[k].valueList[response.varList[k].valueList.length-1].TIME).getTime()
                                if(endListTime> new Date(this.endTime).getTime()){
                                    //删除数组中最后一个元素
                                    response.varList[k].valueList.pop();
                                }
                            }
                            //判断如果切换历史数据过来的 延迟1秒执行，否则实时数据有可能还没有更新结束，导致界面报错
                            if(this.isOpenType == true){
                                setTimeout(()=>{
                                    this.ShowDataOnCurve(response,"history");
                                    this.isOpenType= false;
                                },1000)
                            }else{
                                this.ShowDataOnCurve(response,"history");
                            }
                        }).catch((error) => {
                            if(error.error == "获取历史请求较多，请等待"){
                                this.getHistorydata(this.HisData[i],i);
                            }else{
                                this.$Notice.warning({
                                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                                    desc: error,
                                });
                                this.HisData.length = 0;
                            }

                        })
                    }
                    this.isProgress = false;
                    if(this.isProgress == false){
                        this.setupTow = this.setup;
                    }
                })

            }
            //关闭加载中
            this.$Spin.hide();
        },
        async getHistorydatas(data){
            var percentage = 100/this.HisData.length;
            await this.fvSystemApi.getHistory(this.HisData[i]).then( (response) => {
                //请求回来更新进度环百分比
                this.progressNumber = percentage*(i+1);
                for(var k in response.varList){
                    ///用于判断是否是最后一个元素时间超出时间范围 超出删除最后一个元素
                    var endListTime = new Date(response.varList[k].valueList[response.varList[k].valueList.length-1].TIME).getTime()
                    if(endListTime> new Date(this.endTime).getTime()){
                        //删除数组中最后一个元素
                        response.varList[k].valueList.pop();
                    }
                }
                //判断如果切换历史数据过来的 延迟1秒执行，否则实时数据有可能还没有更新结束，导致界面报错
                if(this.isOpenType == true){
                    setTimeout(()=>{
                        this.ShowDataOnCurve(response,"history");
                        this.isOpenType= false;
                    },1000)
                }else{
                    this.ShowDataOnCurve(response,"history");
                }
            }).catch((error) => {
                if(error.error == "获取历史请求较多，请等待"){
                    setTimeout(()=>{
                        this.getHistorydatas(data,i);
                    },1000)
                }else{
                    console.log('失败：' + error);
                }

            })
        },
        async getHistorydata(data,i){
            var percentage = 100/this.HisData.length;
            await this.fvSystemApi.getHistory(data).then( (response) => {
                //请求回来更新进度环百分比
                this.progressNumber = percentage*(i+1);
                for(var k in response.varList){
                    ///用于判断是否是最后一个元素时间超出时间范围 超出删除最后一个元素
                    var endListTime = new Date(response.varList[k].valueList[response.varList[k].valueList.length-1].TIME).getTime()
                    if(endListTime> new Date(this.endTime).getTime()){
                        //删除数组中最后一个元素
                        response.varList[k].valueList.pop();
                    }
                }
                //判断如果切换历史数据过来的 延迟1秒执行，否则实时数据有可能还没有更新结束，导致界面报错
                if(this.isOpenType == true){
                    setTimeout(()=>{
                        this.ShowDataOnCurve(response,"history");
                        this.isOpenType= false;
                    },1000)
                }else{
                    this.ShowDataOnCurve(response,"history");
                }
            }).catch((error) => {
                if(error.error == "获取历史请求较多，请等待"){
                    setTimeout(()=>{
                        this.getHistorydata(data,i);
                    },1000)
                }else{
                    console.log('失败：嗲用');
                }

            })
        },
        makeMessageHis:function(){
            if(this.store.length <= 0){
                return null;
            }
            var varList = [];
            for(var i = 0; i < this.dbVar.length; i++){
                varList.push(this.dbVar[i].split("$").join(""));
            }

            var startTime = new Date(this.startTime).getTime();
            var endTime = new Date(this.endTime).getTime();
            var hisStep = this.timeStep;
            var hisType = this.hisType;
            
            if(endTime>(new Date().getTime()+2592000000)){
                this.$Notice.warning({
                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                    desc: this.$store.state.system.$.languageName == "ch" ?'时间已经超出最大可选范围时间' : 'The maximum optional range time has been exceeded',
                });
                return;
            }else{
                if(endTime>new Date().getTime()){
                    if((endTime - new Date().getTime())/1000/hisStep>9999){
                        this.$Notice.warning({
                            title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                            desc: this.$store.state.system.$.languageName == "ch" ?'未来时间点已经超出1w，请调整时间间隔' : 'The future time point has exceeded 1W, please adjust the time interval',
                        });
                        return;
                    }
                }
            }
            if(endTime - startTime < 1000){
                this.$Notice.warning({
                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                    desc: this.$store.state.system.$.languageName == "ch" ?'结束时间不能小于或等于开始时间' : 'The end time cannot be less than or equal to the start time',
                });
                this.isloading = false;
                return
            }
            //存储 数据列表
            var  dataList  = [];
            this.HisData = [];
            //清空临时数据
            this.setTemporaryData = [];
            //计算点数 （结束时间 - 开始时间） / 时间间隔 * 多少pv点
            var point = Math.abs(endTime - startTime) / (hisStep * 1000) * varList.length;

            //如果总条数大于10000
            if(point>10000){
                //一条数据的个数 把时间分为多少段
                var list = Math.ceil(((endTime/1000) - (startTime/1000))/hisStep*varList.length/10000);
                //var list = Math.ceil((((endTime/1000) - (startTime/1000))/varList.length)/(10000/varList.length));

                //用于计算时间次数与分批的计算时间差
                //var endList = ((endTime - startTime)/(hisStep*1000));

                //遍历出 需要请求的报文数组
                for(var i=0;i<list;i++){
                    if(i == 0){
                        var data = {
                            head: "dataLayer",
                            message :{
                                head: "getHisData",
                                varList : varList,
                                startTime : startTime,
                                endTime : startTime+parseInt(((endTime - startTime))/list),
                                hisType : hisType,
                                hisStep : hisStep
                            }
                        }
                    }else{
                        if((dataList[i-1].message.endTime)+parseInt(((endTime - startTime))/list)>endTime){
                            var data =  {
                                head: "dataLayer",
                                message :{
                                    head: "getHisData",
                                    varList : varList,
                                    startTime : dataList[i-1].message.endTime,
                                    endTime : endTime,
                                    hisType : hisType,
                                    hisStep : hisStep
                                }
                            }
                            dataList.push(data)
                            break
                        }else{
                            var data =  {
                                head: "dataLayer",
                                message :{
                                    head: "getHisData",
                                    varList : varList,
                                    startTime : dataList[i-1].message.endTime,
                                    endTime : dataList[i-1].message.endTime+parseInt(((endTime - startTime))/list),
                                    hisType : hisType,
                                    hisStep : hisStep
                                }
                            }
                        }
                    }
                    dataList.push(data)
                }
            }else{
                var data =  {
                    head: "dataLayer",
                    message :{
                        head: "getHisData",
                        varList : varList,
                        startTime : startTime,
                        endTime : endTime,
                        hisType : hisType,
                        hisStep : hisStep
                    }
                }
                dataList.push(data);
            }
            this.HisData = dataList;
        },
        //验证时间间隔
        testingStep(value){
            if(value <1){
                this.$Notice.warning({
                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                    desc: this.$store.state.system.$.languageName == "ch" ?'时间间隔不能小于1!' : 'The time interval cannot be less than one factorial'
                });
                return;
            }
        },
        makeMessage:function(){
            if(this.store.length <= 0){
                return null;
            }
            var varList = [];
            for(var i = 0; i < this.dbVar.length; i++){
                varList.push(this.dbVar[i].split("$").join(""));
            }
            if(this.applicationHistory==1&&this.dataType == 0){
                var tStart=new Date().getTime();
                var startTime =tStart-(this.timeLengthStep*1000);
                var endTime = tStart + this.timeStep;
            }else{
                var startTime = new Date(this.startTime).getTime();
                var endTime = (new Date(this.endTime).getTime())+(this.timeStep*1000);
            }
            if(endTime - startTime < 1000){
                this.$Notice.warning({
                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                    desc: this.$store.state.system.$.languageName == "ch" ? '结束时间不能小于或等于开始时间' : "The end time cannot be less than or equal to the start time"
                });
                this.$Spin.hide();
                return
            }
            var hisStep = this.timeStep;
            //设置为0，是趋势历史，没有原始历史接口所以写为固定值
            var hisType = this.hisType;
            var hisMessage = {
                "head": "dataLayer",
                "message" : {
                    "head": "getHisData",
                    "varList": varList,//["a.PV","b.PV"]
                    "startTime": startTime,//起始时间 Date().GetTime
                    "endTime": endTime,//时间跨度
                    "hisType": hisType,  // 0真实历史值, 1 步长历史值
                    "hisStep": hisStep  //步长单位秒
                }
            };
            return hisMessage;
        },
        //设置组件整体显隐
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        //设置组件是否可用
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        //添加曲线以及同时设置曲线颜色
        AddDataEx:function(dataName, dataDesc,colorNumber){
            if(this.isProgress == true){
                this.$Notice.warning({
                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                    desc: false ? '' : this.$store.state.system.$.languageName == "ch" ?'当前曲线未加载完成稍后在试!' : 'The current curve is not loaded and try again later!'
                });
                return;
            }
            if(colorNumber!=undefined){
                var colorArr = window.FColorToRGB.getColors();
                var colorRgb = colorArr[colorNumber];
                colorRgb="rgb("+colorRgb[0]+","+colorRgb[1]+","+colorRgb[2]+")"
                var iscolor = colorRgb;
            }else{
                var iscolor = "#000";
            }
            this.isColorArr.push({
                "name":dataName,
                "color":iscolor
            })

            this.AddData(dataName,dataDesc);
        },
        //添加点
        AddData:function(dataName,dataDesc){
            //判断添加点是否以数字开头
            // var namelist = dataName;
            // namelist = namelist.split(".");
            // for(var i=0;i<namelist.length;i++){
            //     if(!isNaN(namelist[i][0])){
            //        this.$Notice.warning({
            //             title: '警告',
            //             desc: '添加失败！点不能以数字开头'
            //         });
            //         return;
            //     }
            // }
            //判断曲线名称是否重复
            for(var j in this.option.series){
                if(this.option.series[j].name == dataDesc){
                    this.$Notice.warning({
                        title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                        desc: this.$store.state.system.$.languageName == "ch" ?'曲线名称重复！' : "Curve name duplicate!"
                    });
                    return;
                }
            }
            if(dataDesc == undefined || dataDesc == null || dataDesc == ""){
                dataDesc = this.defaultName + this.defaultNo;
                this.defaultNo++;
                if(this.defaultNo > 1000){
                    this.defaultNo = 0;
                }
            }
            if(this.isProgress == true){
                this.$Notice.warning({
                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                    desc: false ? '' : this.$store.state.system.$.languageName == "ch" ? '当前曲线未加载完成稍后在试!' : 'The current curve is not loaded and try again later!'
                });
                return;
            }
            this.HisData = [];
            if(dataName.indexOf(".PV") >0){
                dataName= dataName.replace(".PV","")
            }
            this.dbVar = this.dbVar ? this.dbVar : [];

            if(this.dbVar){
                var ishas = false;
                var closeViewMessage = {
                    "head": "closeView",
                    "dbVar": []
                };//"closeView,";
                for(var j=0; j<this.dbVar.length; j++){
                    closeViewMessage.dbVar.push(this.dbVar[j]);
                    if(dataName == this.dbVar[j]){
                        ishas = true;
                        this.$Notice.warning({
                            title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                            desc: false ? '' : this.$store.state.system.$.languageName == "ch" ?'此点已经添加过曲线，请重新添加！' : 'This point has been added to the curve, please add again!'
                        });
                        return;
                    }
                }
                if(!ishas){
                    this.dbVar.push("$"+dataName.split(".").join(".$"));
                }
            }
            var data = this.makeMessage();
            this.registerTag(dataName,dataDesc);
            //  dojo.Workbench.sendMessage(window.MakeGetRegistryTag(dataName,dataDesc), this.registerTag.bind(this));
        },
        /**
        * 作用： 弹窗点击事件按钮
        * 参数： deleteName 删除点名称：测试.测试1.pv
        */
        DelDataBtn: function(){
            // if(dataName.indexOf(".PV") >0){
            //     dataName= dataName.replace(".PV","")
            // }
            if(this.deleteName==""){
                return
            }
            for(var i = 0; i < this.newStore.length; i++){
                if(this.deleteName === this.newStore[i].data && this.newStore.length > 0){
                    this.newStore.splice(i, 1);
                    // this.store.splice(i,1);
                    this.curveListData.splice(i,1);
                    this.updateRealTimeCurve();
                    this.delFormDbVar(this.deleteName);
                    this.UpDateData();
                    //清理注册点
                    //this.fvSystemApi.endReal();
                    return;
                }
            }
            console.log("dbVar中不存在该点");
        },
        /**
        * 作用： 脚本函数删除点
        * 参数： deleteName 删除点名称：测试.测试1.pv
        */

        DelData: function(deleteName){
            if(deleteName==""){
                return
            }
            for(var i = 0; i < this.newStore.length; i++){
                if(deleteName === this.newStore[i].data && this.newStore.length > 0){
                    this.newStore.splice(i, 1);
                    this.store.splice(i,1);
                    this.curveListData.splice(i,1);
                    this.updateRealTimeCurve();
                    this.delFormDbVar(deleteName);
                    //this.UpDateData();
                    //清理注册点
                    //this.fvSystemApi.endReal();
                    return;
                }
            }
            console.log("dbVar中不存在该点");
        },
        //请求历史调用
        ShowDataOnCurve: function(rebackMessage,value){
            if(value == "history"){
                this.getInitHisTimeData(rebackMessage);
            }else{
                this.initHisTimeData(rebackMessage);
            }
            if(this.isAllDle){
                this.upDateOption();
                this.showCurve();
                this.isAllDle=false;
            }else{
                if(this.dataType == 1 || !this.applicationHistory){
                    this.upDateOption();
                    this.showCurve();
                }
            }
            this.isloading = false;
        },
        ClearData: function(){
            this.store = [];
            this.newStore = [];
            this.dbVar = [];
            this.isColorArr = [];
            var rebackMessage = {
                head: "getHisData",
                varList:[
                    {
                        valueList:[],
                        varName: ""
                    }
                ]
            }
            this.isAllDle = true;
            this.ShowDataOnCurve(rebackMessage);
            this.curve.setOption(this.option,true);
            // this.curve.clear()
            //this.UpDateData();
            this.isloading = false;
            return;
        },
        /**
         * 作用：设置开始时间
         */
        SetStartTime: function(dataStartTime){
            if(new Date(dataStartTime).getTime() > new Date().getTime()) {
                this.startTimeOut = true;
                var name = this.$store.state.system.$.languageName== "ch" ? "开始时间以超出当前时间-":"Start time to exceed current time-";
                alert(name+dataStartTime +"-"+new Date());
            }
            this.startTimeOut = false;
            this.newStartTime = dataStartTime;
            this.startTime = dataStartTime;
        },
        /**
         * 作用：设置结束时间
         */
        SetEndTime: function(dataEndTime){
            if(new Date(dataEndTime).getTime() > new Date().getTime()) {
                this.endTimeOut = true;
                var name = this.$store.state.system.$.languageName== "ch" ? "结束时间以超出当前时间-" : "End time to exceed the current time";
                alert(name+ dataEndTime + "-" + new Date());
                this.endTimeOut = false;
                //return;
            }
            this.newEndTime = dataEndTime;
            this.endTime = dataEndTime;
        },
        /**
         * 作用：设置时间间隔
         */
        SetTimeStep: function(dataTimeStep){
            this.newTimeStep = dataTimeStep;
        },
        /**
         * 作用：切换 获取实时 和 历史
         */
        UpDateCurveType:function(dataCurveType){
            this.startTimeOut = false;
            this.endTimeOut = false;
            this.isOpenType = true;
            this.newCurveType = dataCurveType;
        },
        GetCount(){
            return this.store.length;
        },
        SetColorByIndex(index,colorNumber){
            if(this.store[index]){
                var colorArr = window.FColorToRGB.getColors();
                var colorRgb = colorArr[colorNumber];
                colorRgb="rgb("+colorRgb[0]+","+colorRgb[1]+","+colorRgb[2]+")";
                this.store[index].color = colorRgb;
                this.upDateOption();
            }

        },
        //设置曲线颜色
        SetColor: function(curveName,curveNumber){
            var colorArr = window.FColorToRGB.getColors();
            var colorRgb = colorArr[curveNumber];
            colorRgb="rgb("+colorRgb[0]+","+colorRgb[1]+","+colorRgb[2]+")"
            for(var i = 0;i<this.store.length;i++){
                if(this.store[i].name==curveName){
                    if(this.store[i].color!=colorRgb){
                        this.store[i].color=colorRgb;
                        this.upDateOption();
                    }else{
                        alert(this.$store.state.system.$.languageName== "ch" ?"颜色以添加！":"Color to add!");
                    }
                }
            }
        },
        /**
         * 作用：动态设置警戒线是否显示
         * 参数 name：曲线名称
	     * 参数 type：大于 0 上限，小于等于0 下限
	     * 参数 show：大于 0 显示，小于等于0 隐藏
         */
        SetLimitIsShow : function (name,isUpOrLo,isShow) {
            if(isShow <= 0){
                isShow = false;
            }else{
                isShow = true;
            }
            for(var i = 0; i<this.store.length; i++){
                if(this.store[i].name == name){
                    if(isUpOrLo > 0){//上限

                        this.store[i].upperShow = isShow;
                        this.upDateOption();
                        return;
                    }else{//下限
                        this.store[i].lowerShow = isShow;
                        this.upDateOption();
                        return;
                    }
                }
            }
            var data = this.$store.state.system.$.languageName== "ch" ? " :没有找到该曲线，请检查名称是否正确！":":The curve was not found, please check the name is correct!"
            alert(name + data);
        },
        /**
         * 作用：动态设置警戒线下限值
         * 参数 name：曲线名称
	     * 参数 type：大于 0 上限，小于等于0 下限
	     * 参数 value：要设置的限值
	     * 参数 isShow：是否显示
         */
        SetLimit : function (name,isUpOrLo,value,isShow) { //曲线名称，上/0或下/1，值，是否显示0/1
            var isHsa = true;
            if(isShow <= 0){
                isShow = false;
            }else{
                isShow = true;
            }
            /*if(value <= 0){
                value = false;
            }else{
                value = true;
            }*/
            for(var i = 0; i<this.store.length; i++){
                if(this.store[i].name == name){
                    if(isUpOrLo > 0){//上限
                        this.store[i].upperLimit = value;
                        this.store[i].upperShow = isShow;
                        isHsa = false;
                    }else{//下限
                        this.store[i].lowerLimit = value;
                        this.store[i].lowerShow = isShow;
                        isHsa = false;
                    }
                }
            }
            if(isHsa){
                this.onSetLimit(name,isUpOrLo,value,isShow)
            }else{
                this.upDateOption();
            }
        },
        /**
         * 作用：获取警戒线的上或下的显示隐藏
         * 参数：上/0或下/1
         */
        GetLimitIsShow : function (name,isUpOrLo) {//曲线名称，上/0或下/1
            for(var i = 0; i<this.store.length; i++){
                if(this.store[i].name == name){
                    if(isUpOrLo > 0){//上限
                        return this.store[i].upperShow;
                    }else{//下限
                        return this.store[i].lowerShow;
                    }
                }

            }
            var data = this.$store.state.system.$.languageName== "ch" ? ":没有找到该曲线，请检查名称是否正确！":":The curve was not found, please check the name is correct!"
            alert(name+data);
            return 0;
        },
        //回调警戒线监听
        onSetLimit : function(name,isUpOrLo,value,isShow){
            if(this.limitInfo[name]){
                if(isUpOrLo){
                    this.limitInfo[name].upperLimit = value;
                    this.limitInfo[name].upperIsShow = isShow;
                }else{
                    this.limitInfo[name].lowerLimit = value;
                    this.limitInfo[name].lowerIsShow = isShow;
                }
            }else{
                if(isUpOrLo){
                    this.limitInfo[name] = {
                        upperLimit : value,
                        upperIsShow : isShow
                    }
                }else{
                    this.limitInfo[name] = {
                        lowerLimit : value,
                        lowerIsShow : isShow
                    }
                }
            }
        },
        //动态获取警戒线的值
        GetLimit : function (name,isUpOrLo){ //曲线名称，上/0或下/1
            for(var i = 0; i<this.store.length; i++){
                if(this.store[i].name == name){
                    if(isUpOrLo > 0){//上限
                        return this.store[i].upperLimit;
                    }else{//下限
                        return this.store[i].lowerLimit;
                    }
                }
            }
            var data = this.$store.state.system.$.languageName== "ch" ? " :没有找到该曲线，请检查名称是否正确！":":The curve was not found, please check the name is correct!";
            alert(name+data);
            return -9999;
        },
        Print:function(){
            var system ={};
            var p = navigator.platform;
            system.win = p.indexOf("Win") == 0;
            system.mac = p.indexOf("Mac") == 0;
            system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
            if(system.win||system.mac||system.xll){
                var addWindow = window.open('','width=100%,height=100%');
                var img = this.chart.childNodes[0].firstChild.toDataURL("image/png");
                addWindow.document.body.innerHTML = '<img src="'+img+'"/>';
                setTimeout(function(){//避开异步问题
                    addWindow.print();
                    addWindow.close();
                }.bind(this),500);
            }else{
                alert(this.$store.state.system.$.languageName== "ch" ? "手机浏览器暂不支持打印操作" :"The mobile browser does not support printing operations");
            }
        },
        /**
         * 作用：获取设置的结束时间
         * 返回值：毫秒值
         */
        GetEndTime(){
            return new Date(this.endTime).getTime();
        },
        /**
         * 作用：获取设置的开始时间
         * 返回值：毫秒值
         */
        GetStartTime(){
            return new Date(this.startTime).getTime();
        },
        timestampToTime(timestamp) {
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '/';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
            var D = date.getDate() < 10 ? '0'+date.getDate() + ' ' : date.getDate() + ' ';
            var h = date.getHours() < 10 ? '0'+date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0'+date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds();
            return Y+M+D+h+m+s;
        },

    },

}
</script>
<style>
/* loading背景透明 */
    .fvMultiTypeCurve .ivu-spin-fix{
        background-color: rgba(255,255,255,0);
    }
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvMultiTypeCurve/fvMultiTypeCurve.vue